import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridChartCustomAttributes } from '@ddt-web/chart';
import { ApplicationPathConstants, ColorsConfig } from '@ddt-web/config';
import { ComponentDataSelectorUtil, TabData } from '@ddt-web/data-service';

@Component({
	selector: 'ate-fund-holdings',
	templateUrl: './fund-holdings.component.html',
	styleUrls: ['./fund-holdings.component.scss']
})
export class FundHoldingsComponent implements OnChanges, OnInit {
	@Input() public data: TabData;
	@Input() public selectedPortfolioIndex: number;
	@Input() public isSingleStocksView: boolean;
	@Input() public showReviewHoldingsLink: boolean = true;

	public numberOfMutualFunds: number;
	public numberOfFunds: number;
	public numberOfEtfs: number;
	public numberOfSingleStocks: number;

	public mutualFundsChartAttributes: GridChartCustomAttributes;
	public etfsChartAttributes: GridChartCustomAttributes;
	public singleStocksChartAttributes: GridChartCustomAttributes;
	public fundsChartAttributes: GridChartCustomAttributes;

	public fundHoldingRoute: string;
	public queryParams: any;

	constructor(private route: ActivatedRoute) { }

	public ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			this.queryParams = params;
		});
		this.fundHoldingRoute = `/${ApplicationPathConstants.PORTFOLIO_ANALYSIS_PATHS.OVERVIEW}`;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.data) {
			this.numberOfSingleStocks = <number>ComponentDataSelectorUtil.cellRawValueSelector(this.data.tableData[0], 'SINGLE STOCKS', this.selectedPortfolioIndex);
			this.numberOfMutualFunds = <number>ComponentDataSelectorUtil.cellRawValueSelector(this.data.tableData[0], 'MUTUAL FUNDS', this.selectedPortfolioIndex);
			this.numberOfFunds = <number>ComponentDataSelectorUtil.cellRawValueSelector(this.data.tableData[0], 'FUNDS', this.selectedPortfolioIndex);
			this.numberOfEtfs = <number>ComponentDataSelectorUtil.cellRawValueSelector(this.data.tableData[0], 'ETFs', this.selectedPortfolioIndex);

			this.generateGridChartAttributes();
		}
	}

	public generateGridChartAttributes(): void {
		this.mutualFundsChartAttributes = {
			numberOfNode: this.numberOfMutualFunds,
			redColor: ColorsConfig.INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR.RED,
			greenColor: ColorsConfig.INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR.GREEN,
			blueColor: ColorsConfig.INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR.BLUE,
			maximumNumberOfRow: 13
		};

		this.etfsChartAttributes = {
			numberOfNode: this.numberOfEtfs,
			redColor: ColorsConfig.INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR.RED,
			greenColor: ColorsConfig.INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR.GREEN,
			blueColor: ColorsConfig.INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR.BLUE,
			maximumNumberOfRow: 13
		};

		this.singleStocksChartAttributes = {
			numberOfNode: this.numberOfSingleStocks,
			redColor: ColorsConfig.INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR.RED,
			greenColor: ColorsConfig.INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR.GREEN,
			blueColor: ColorsConfig.INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR.BLUE,
			maximumNumberOfRow: 13
		};

		this.fundsChartAttributes = {
			numberOfNode: this.numberOfFunds,
			redColor: ColorsConfig.INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR.RED,
			greenColor: ColorsConfig.INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR.GREEN,
			blueColor: ColorsConfig.INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR.BLUE,
			maximumNumberOfRow: 13
		};
	}
}
